import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup } from 'modules/theme';
import { AuthBox, Links } from '../styles';
import { FormWrapper, FormColumn } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { ControlLabel } from 'react-bootstrap';
import { Alert } from 'modules/common/utils';
import { withRouter } from 'react-router';

const propTypes = {
  Otp: PropTypes.func.isRequired
};

class Otp extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.state = {
      email: '',
      otp: '',
      value: '',
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
      otp5: '',
      otp6: ''
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 200) {
      Alert.success(`${data.message}`);
    } else {
      Alert.error(`${data.message}`);
    }
  }

  saveData(e) {
    let _this = this;
    let email = localStorage.getItem('email');
    e.preventDefault();
    let tData = {
      email: email,
      otp:
        this.state.otp1 +
        this.state.otp2 +
        this.state.otp3 +
        this.state.otp4 +
        this.state.otp5 +
        this.state.otp6
    };
    // this.mAPI.sendPostAPI(
    //   `auth/verify-account`,
    //   tData,
    //   data => {
    //     console.log(JSON.stringify(data, null, 2));
    //     window.location.href = '/';
    //   },
    //   (errorCode, data) => {
    //     this.apiResponse(errorCode, data);
    //   },
    //   'public',
    //   '',
    //   'PATCH'
    // );
  }

  render() {
    const { __ } = this.context;
    return (
      <div style={{ width: '485px', margin: 'auto' }}>
        <AuthBox style={{ textAlign: 'center' }}>
          <h2 style={{ marginBottom: '10px' }}>
            {__('Please confirm your email')}
          </h2>
          <p>Code is send to aliroy4585@school.com</p>
          <form onSubmit={e => this.saveData(e)} className="otp">
            {/* <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('', {
                defaultValue: '',
                placeholder: '',
                autoFocus: true,
                required: true,
                id: 'otp',
                value: this.state.otp,
                onChange: e => {
                  this.setState({ otp: e.target.value });
                }
              })}
            </FormColumn>
          </FormWrapper> */}
            <FormWrapper>
              <FormColumn style={{paddingRight: '0px', margin: '5px'}}>
                <FormGroup>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: '',
                    autoFocus: false,
                    required: true,
                    id: 'otp1',
                    value: this.state.otp1,
                    onChange: e => {
                      const re = /^[\.0-9]*$/;
                      if (e.target.value.length == 2 || !re.test(e.target.value)) {
                        return false;
                      }
                      this.setState({ otp1: e.target.value });
                    }
                  })}
                </FormGroup>
              </FormColumn>
              <FormColumn style={{paddingRight: '0px', margin: '5px'}}>
                <FormGroup>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: '',
                    autoFocus: false,
                    required: true,
                    id: 'otp2',
                    value: this.state.otp2,
                    onChange: e => {
                      const re = /^[\.0-9]*$/;
                      if (e.target.value.length == 2 || !re.test(e.target.value)) {
                        return false;
                      }
                      this.setState({ otp2: e.target.value });
                    }
                  })}
                </FormGroup>
              </FormColumn>
              <FormColumn style={{paddingRight: '0px', margin: '5px'}}>
                <FormGroup>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: '',
                    autoFocus: false,
                    required: true,
                    id: 'otp3',
                    value: this.state.otp3,
                    onChange: e => {
                      const re = /^[\.0-9]*$/;
                      if (e.target.value.length == 2 || !re.test(e.target.value)) {
                        return false;
                      }
                      this.setState({ otp3: e.target.value });
                    }
                  })}
                </FormGroup>
              </FormColumn>
              <FormColumn style={{paddingRight: '0px', margin: '5px'}}>
                <FormGroup>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: '',
                    autoFocus: false,
                    required: true,
                    id: 'otp4',
                    value: this.state.otp4,
                    onChange: e => {
                      const re = /^[\.0-9]*$/;
                      if (e.target.value.length == 2 || !re.test(e.target.value)) {
                        return false;
                      }
                      this.setState({ otp4: e.target.value });
                    }
                  })}
                </FormGroup>
              </FormColumn>
              <FormColumn style={{paddingRight: '0px', margin: '5px'}}>
                <FormGroup>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: '',
                    autoFocus: false,
                    required: true,
                    id: 'otp5',
                    value: this.state.otp5,
                    onChange: e => {
                      const re = /^[\.0-9]*$/;
                      if (e.target.value.length == 2 || !re.test(e.target.value)) {
                        return false;
                      }
                      this.setState({ otp5: e.target.value });
                    }
                  })}
                </FormGroup>
              </FormColumn>
              <FormColumn style={{paddingRight: '0px', margin: '5px'}}>
                <FormGroup>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: '',
                    autoFocus: false,
                    required: true,
                    id: 'otp6',
                    value: this.state.otp6,
                    onChange: e => {
                      const re = /^[\.0-9]*$/;
                      if (e.target.value.length == 2 || !re.test(e.target.value)) {
                        return false;
                      }
                      this.setState({ otp6: e.target.value });
                    }
                  })}
                </FormGroup>
              </FormColumn>
            </FormWrapper>

            <Links style={{ marginTop: '0px' }}>
              Didn’t recieve code? {'  '}
              <Link to="/sign-in">{__('Request again')}</Link>
            </Links>

            <Button
              btnStyle="default"
              type="submit"
              block
              style={{ marginTop: '30px', padding: '13px' }}
            >
              Verify and Create Account
            </Button>
          </form>
        </AuthBox>
      </div>
    );
  }
}

Otp.propTypes = propTypes;
Otp.contextTypes = {
  __: PropTypes.func
};

export default withRouter(Otp);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Otp.js